module.exports = __webpack_public_path__ + "r-v3/img/delete_red.a632cf14.svg";